var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.costTableVisibleTwo
      ? _c("div", { staticClass: "maskDiv" }, [
          _c("div", { staticClass: "costTable" }, [
            _c(
              "div",
              {
                staticStyle: { position: "sticky", top: "0", "z-index": "10" },
              },
              [
                _c("div", { staticClass: "controlDiv" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        width: "1025px",
                        "justify-content": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "margin-right": "250px",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "controlDiv_button",
                              on: {
                                click: function ($event) {
                                  _vm.showCostTableHead = true
                                },
                              },
                            },
                            [_vm._v("打开数据汇总板")]
                          ),
                          _c("i", {
                            staticClass: "el-icon-arrow-down",
                            staticStyle: {
                              "font-size": "18px",
                              color: "#ddd",
                              "margin-left": "5px",
                            },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "controlDiv_button",
                              on: {
                                click: function ($event) {
                                  _vm.showCostTableHead = false
                                },
                              },
                            },
                            [_vm._v("收起数据汇总板")]
                          ),
                          _c("i", {
                            staticClass: "el-icon-arrow-up",
                            staticStyle: {
                              "font-size": "18px",
                              color: "#ddd",
                              "margin-left": "5px",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "shareIcon_box" },
                    [
                      _c("svg-icon", {
                        staticStyle: { width: "26px", height: "26px" },
                        attrs: { iconClass: "share1" },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "saveCostTable",
                          on: {
                            click: function ($event) {
                              _vm.costTableVisibleTwo = false
                            },
                          },
                        },
                        [_vm._v("关闭")]
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showCostTableHead,
                        expression: "showCostTableHead",
                      },
                    ],
                    staticClass: "costTableHead",
                    staticStyle: { height: "2.75rem" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                        },
                      },
                      [
                        _c("div", [
                          _c("div", { staticClass: "info_box" }, [
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "30px" } },
                              [_vm._v("行程编号：")]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-left": "15px",
                                  "margin-right": "30px",
                                },
                              },
                              [_vm._v(_vm._s(_vm.planInfo.id))]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "border-left": "2px solid #bbb",
                                  "border-right": "2px solid #bbb",
                                  padding: "0 30px",
                                  "max-width": "420px",
                                  overflow: "hidden",
                                  "white-space": "nowrap",
                                  "text-overflow": "ellipsis",
                                },
                              },
                              [_vm._v(_vm._s(_vm.planInfo.planName))]
                            ),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "30px" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.dateFormatYMD(
                                        _vm.budgetInfo.departureDate,
                                        "/"
                                      )
                                    ) +
                                    "-" +
                                    _vm._s(
                                      _vm.dateFormatYMD(
                                        _vm
                                          .dateAddDay(
                                            _vm.budgetInfo.departureDate,
                                            _vm.planInfo.planDay - 1
                                          )
                                          .getTime(),
                                        "/"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "costTableHead_body" }, [
                            _c("div", { staticStyle: { height: "1.66rem" } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "appraiser_box",
                                  staticStyle: { height: "1.66rem" },
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "appraiser_info",
                                        staticStyle: { height: "1.66rem" },
                                      },
                                      [
                                        _vm._m(0),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "appraiser_info_right",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "info_box_right" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "info_name" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.budgetInfo
                                                          .createName
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c("img", {
                                                  staticClass: "info_avatar",
                                                  attrs: {
                                                    src: _vm.budgetInfo
                                                      .imageUrl,
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._m(1),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "7rem",
                                  height: "1.66rem",
                                  "margin-left": "10px",
                                  "margin-top": "20px",
                                  display: "flex",
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                _c("div", [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "stroke_info_item",
                                          staticStyle: {
                                            width: "2.24rem",
                                            "margin-right": "0.1rem",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "distanceInfo" },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(_vm.planInfo.planDay)
                                                ),
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-size": "14px",
                                                    color:
                                                      "rgba(86, 89, 118, 100)",
                                                  },
                                                },
                                                [_vm._v("天数")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "distanceInfo" },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.planInfo.countryNumber
                                                  )
                                                ),
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-size": "14px",
                                                    color:
                                                      "rgba(86, 89, 118, 100)",
                                                  },
                                                },
                                                [_vm._v("国家")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "distanceInfo" },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.planInfo.cityNumber
                                                  )
                                                ),
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-size": "14px",
                                                    color:
                                                      "rgba(86, 89, 118, 100)",
                                                  },
                                                },
                                                [_vm._v("城市")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "stroke_info_item" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "distanceInfo" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "75px",
                                                    height: "30px",
                                                    background:
                                                      "rgba(219, 78, 26, 0.6)",
                                                    "text-align": "center",
                                                    "line-height": "30px",
                                                    color: "white",
                                                    "font-size": "16px",
                                                  },
                                                },
                                                [_vm._v("核算人数")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "75px",
                                                    height: "25px",
                                                    "margin-top": "5px",
                                                    "text-align": "center",
                                                    "font-size": "18px",
                                                    color: "#565976",
                                                    "line-height": "25px",
                                                    "font-weight": "bold",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.budgetInfo.useNumber
                                                    ) + "人"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "quotation_box",
                                      staticStyle: { background: "'#F5F7FA'" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "quotation_box_name" },
                                        [
                                          _vm._v(
                                            "报价单 " +
                                              _vm._s(
                                                _vm.dateFormatYMDHM(
                                                  _vm.budgetInfo.createTime,
                                                  "-"
                                                ) + "报价"
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "3.24rem",
                                      height: "1.67rem",
                                      background: "white",
                                      "border-radius": "5px",
                                      display: "flex",
                                      "justify-content": "space-between",
                                      "flex-direction": "column",
                                      padding: "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "space-between",
                                          "font-size": "14px",
                                          color: "#DB4E1A",
                                          "align-items": "flex-end",
                                        },
                                      },
                                      [
                                        _c("div", [_vm._v("行程总预算")]),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "font-weight": "bold",
                                              "font-size": "20px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.dataObj.saleTotalPrice
                                              ) + "￥"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._m(2),
                                    _vm._m(3),
                                    _vm._m(4),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._m(5),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: { background: "white", padding: "10px 20px" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          height: "83px",
                          "align-items": "center",
                          "border-bottom": "1px solid #ddd",
                        },
                      },
                      [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _vm._m(6),
                          _c("div", { staticClass: "filter_box" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    on: {
                                      change: function ($event) {
                                        return _vm.handleCheckAllChange(2)
                                      },
                                    },
                                    model: {
                                      value: _vm.checkAllState,
                                      callback: function ($$v) {
                                        _vm.checkAllState = $$v
                                      },
                                      expression: "checkAllState",
                                    },
                                  },
                                  [_vm._v("全部项目")]
                                ),
                                _c(
                                  "el-checkbox-group",
                                  {
                                    on: {
                                      change: function ($event) {
                                        return _vm.handleCheckedCitiesChange(2)
                                      },
                                    },
                                    model: {
                                      value: _vm.checkedStateList,
                                      callback: function ($$v) {
                                        _vm.checkedStateList = $$v
                                      },
                                      expression: "checkedStateList",
                                    },
                                  },
                                  _vm._l(
                                    _vm.dataObj.statePriceMap,
                                    function (value, key) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: key,
                                          attrs: { label: Number(key) },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.stockTypeMap[key].typeName
                                            )
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "costTableData",
                style: _vm.showCostTableHead ? "" : "top: 144px;",
              },
              [
                _c("trip-left-day", {
                  ref: "tripLeftDay",
                  attrs: { chenckBudget: _vm.budgetInfo, showShaft: 2 },
                }),
                _c("budget-detail", {
                  attrs: {
                    checkBudget: _vm.budgetInfo,
                    chooseStockTypes: _vm.checkedStateList,
                    showShaft: 3,
                    showCostPrice: false,
                    allStockTypes: _vm.allStockTypes,
                    planProductShowStatus: true,
                  },
                }),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "appraiser_info_box" }, [
      _c("div", { staticClass: "info_title" }, [_vm._v("座右铭")]),
      _c("div", { staticClass: "info_body" }, [
        _vm._v("性价比永远是开心出行的首要前提"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info_ability" }, [
      _c("div", [_vm._v("资深定制师")]),
      _c("div", [_vm._v("共计处理定制需求105件")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "space-between",
          "font-size": "14px",
          color: "#3B7B1A",
          "align-items": "flex-end",
        },
      },
      [
        _c("div", [_vm._v("已抢/预定")]),
        _c(
          "div",
          { staticStyle: { "font-weight": "bold", "font-size": "20px" } },
          [_vm._v("￥")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "space-between",
          "font-size": "14px",
          color: "#FF0206",
          "align-items": "flex-end",
        },
      },
      [
        _c("div", [_vm._v("预定确认中")]),
        _c(
          "div",
          { staticStyle: { "font-weight": "bold", "font-size": "20px" } },
          [_vm._v("￥")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "space-between",
          "font-size": "14px",
          color: "#DB4E1A",
          "align-items": "flex-end",
        },
      },
      [
        _c("div", [_vm._v("预定已确认")]),
        _c(
          "div",
          { staticStyle: { "font-weight": "bold", "font-size": "20px" } },
          [_vm._v("￥")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pieChart" }, [
      _c("div", {
        staticStyle: { width: "3.53rem", height: "3.5rem" },
        attrs: { id: "pieChart" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          width: "0.4rem",
          height: "0.59rem",
          "font-size": "0.2rem",
          color: "white",
          "text-align": "center",
          background: "#DB4E1A",
          "line-height": "0.29rem",
        },
      },
      [_vm._v("行"), _c("br"), _vm._v("程")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }